export default __webpack_public_path__ + "static/media/guide_to_ballad.a6c9e1cd.png";